export default "__VITE_ASSET__63504727__"